const WAITLIST_API = process.env.NEXT_PUBLIC_SERVER_URL || "";

export { WAITLIST_API };
